<script lang="ts">
	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	import '@splidejs/svelte-splide/css';
	import { onMount } from 'svelte';
	export let data: any = [];
	let goibiboRating = { rating: '', scale: '', count: '' };
	let mmtRating = { rating: '', scale: '', count: '' };
	let tripRating = { rating: '', scale: '', count: '' };
	let ctripRating = { rating: '', scale: '', count: '' };
	$: items = data.data;

	const currentYear = new Date().getFullYear();

	onMount(() => {
		const slides = document.querySelectorAll('.splide__slide');
		slides.forEach((slide) => {
			if (slide.getAttribute('role') === 'group') {
				slide.removeAttribute('role');
			}
			slide.removeAttribute('aria-roledescription');
		});
	});
	onMount(async () => {
		try {
			const res = await fetch('/api/ota');
			if (res.ok) {
				const data = await res.json();
				goibiboRating = data.goibibo;
				mmtRating = data.mmt;
				tripRating = data.trip;
				ctripRating = data.ctrip;
			}
		} catch (e) {
			console.error('Gagal ambil data OTA:', e);
		}
	});
</script>

<footer class="text-[#7d704f] pb-36 lg:pb-0">
	<div class="mx-auto container p-5">
		<div class="border border-[#7d704f] p-5 lg:px-10">
			<div class="md:py-10 grid grid-cols-1 lg:grid-cols-6">
				<div class="lg:col-span-2 md:mx-auto md:max-w-sm lg:mx-0">
					<div class="flex items-center justify-center gap-x-3 px-10 lg:gap-x-6">
						<div class="shrink-0 basis-1/3">
							<img class="block" src="/images/thg-logo.webp" alt="THG Logo" loading="lazy" />
						</div>
						<!-- <div class="shrink-0 basis-1/3">
							<img
								class="block"
								src="/images/logo-color.webp"
								alt="Trans Resort Logo"
								loading="lazy"
							/>
						</div> -->
						<div class="shrink-0 basis-1/3">
							<img class="block" src="/images/apps.webp" alt="THG Apps" loading="lazy" />
						</div>
					</div>
					<div class="text-xs text-center mt-4">
						Enjoy guaranteed best rate plus more privileges through our Trans Hotel Group Apps.
						Download and register now!
					</div>
					<div class="flex items-center justify-center gap-1 mt-4">
						<a
							class="flex items-center gap-2 bg-[#7d704f] text-xs text-white !py-2 !px-3 lg:text-sm lg:w-full lg:justify-center lg:!py-3"
							href="https://play.google.com/store/apps/details?id=com.transhotelgroup&amp;referrer=utm_source%3Dtrbwebsite%26utm_medium%3Dpopupbanner%26utm_content%3DPromotional%2BRoom%2BRates%2BStarting%2BFrom%2B1M%26utm_campaign%3DTRB%2BTHG%2BAPP%2BGRAND%2BLAUNCHING%2BSPECIAL%2BOFFERS"
						>
							<span class="text-sm">Download on</span>
							<div class="bg-white rounded-full w-6 h-6 flex items-center justify-center p-1">
								<svg
									class="!fill-[#7d704f]"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M238.84,115.93,71,19.89a14,14,0,0,0-14.12,0A13.68,13.68,0,0,0,50,31.87V224.13a13.68,13.68,0,0,0,6.92,11.94,14,14,0,0,0,14.12,0l167.8-96a13.75,13.75,0,0,0,0-24.14ZM62,217.5V38.5L151.51,128Zm98-81,22.19,22.19L78.4,218.07ZM78.4,37.93l103.79,59.4L160,119.52ZM233,129.58l-.1.06L193,152.49,168.49,128,193,103.51l39.94,22.85.1.06a1.76,1.76,0,0,1,0,3.16Z"
									></path></svg
								>
							</div>
						</a>
						<a
							class="flex items-center gap-2 bg-[#7d704f] text-xs text-white !py-2 !px-3 lg:text-sm lg:w-full lg:justify-center lg:!py-3"
							href="https://apps.apple.com/us/app/trans-hotel-group/id1618144668?utm_source=trbwebsite&amp;utm_medium=popupbanner&amp;utm_campaign=TRB+THG+APP+GRAND+LAUNCHING+SPECIAL+OFFERS&amp;utm_content=Promotional+Room+Rates+Starting+From+1M"
						>
							<span>Download on</span>
							<div class="bg-white rounded-full w-6 h-6 flex items-center justify-center p-1">
								<svg
									class="!fill-[#7d704f]"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M62.62,195.05l-9.45,16A6,6,0,0,1,42.83,205l9.46-16a6,6,0,1,1,10.33,6.1ZM232,154H183.06l-31.31-53a6,6,0,1,0-10.33,6.11l61.41,103.93a6,6,0,0,0,10.34-6.1l-23-38.95H232a6,6,0,0,0,0-12Zm-89.53,0H86.88L157.17,35.05A6,6,0,0,0,146.83,29L128,60.82,109.17,29a6,6,0,0,0-10.34,6.1L121,72.62,72.94,154H24a6,6,0,0,0,0,12H142.47a6,6,0,1,0,0-12Z"
									></path></svg
								>
							</div>
						</a>
					</div>
				</div>
				<div class="lg:col-span-2 mt-12 lg:mt-0 lg:flex-grow">
					<h3 class="Elmessiri font-medium tracking-tight text-center text-xl lg:text-2xl">
						Trans Hotel Group
					</h3>
					<ul class="text-center text-sm space-y-3 mt-4">
						<li>
							<a target="_blank" href="https://www.thetranshotel.com/"
								>The Trans Luxury Hotel Bandung</a
							>
						</li>
						<li>
							<a target="_blank" href="https://www.transresortbali.com/">The Trans Resort Bali</a>
						</li>
						<li>
							<a target="_blank" href="https://www.transluxuryyacht.com/">The Trans Luxury Yacht</a>
						</li>
						<li>
							<a target="_blank" href="https://all.accor.com/hotel/8060/index.id.shtml"
								>Ibis Bandung Trans Studio Hotel</a
							>
						</li>
						<li>
							<a
								target="_blank"
								href="https://www.astonhotelsinternational.com/en/hotel/view/39/aston-tanjung-pinang-hotel---conference-center"
								>Aston Tanjung Pinang Hotel</a
							>
						</li>
						<li>
							<a target="_blank" href="https://fourstarbytranshotel.com/"
								>Four Star by Trans Hotel Bali</a
							>
						</li>
						<li>
							<a target="_blank" href="https://www.fashionbalilegian.com/"
								>Fashion Hotel Legian Bali</a
							>
						</li>
					</ul>
				</div>
				<div class="lg:col-span-2 grid grid-cols-1 lg:grid-cols-2 mt-5 lg:mt-0">
					<div>
						<h3 class="Elmessiri font-medium tracking-tight text-center text-xl lg:text-2xl">
							Prestigious Awards
						</h3>
						<div class="mt-4">
							<Splide
								options={{
									rewind: false,
									gap: 5,
									perPage: 1,
									type: 'loop',
									arrows: false,
									pagination: false,
									autoplay: true,
									interval: 3000,
									pauseOnHover: false
								}}
							>
								{#each items[0].award as item}
									<SplideSlide>
										<img
											class="w-full h-40 object-contain"
											src={item?.path}
											alt={item?.path}
											loading="lazy"
										/>
									</SplideSlide>
								{/each}
								<SplideSlide>
									<a
										href="https://www.kayak.com.au/Denpasar-Hotels-The-Trans-Resort-Bali.2279395.ksp"
										target="_blank"
										><img
											class="w-full h-40 object-contain"
											src="https://content.r9cdn.net/seo-res/badges/v5/DARK_MEDIUM_TRAVEL_AWARDS.png"
											alt="Kayak Travel Awards"
										/></a
									>
								</SplideSlide>
							</Splide>
						</div>
					</div>
					<div>
						<h3 class="Elmessiri font-medium tracking-tight text-center text-xl lg:text-2xl">
							Online Reputation
						</h3>
						<div class="mt-4">
							<Splide
								options={{
									rewind: false,
									gap: 5,
									perPage: 1,
									type: 'loop',
									arrows: false,
									pagination: false,
									autoplay: true,
									interval: 3000,
									pauseOnHover: false
								}}
							>
								{#each items[0].reputation as item}
									<SplideSlide>
										<img
											class="w-full h-40 object-contain"
											src={item?.path}
											alt={item?.path}
											loading="lazy"
										/>
									</SplideSlide>
								{/each}
								<!-- <SplideSlide class="py-5 lg:py-0 px-5">
									{#if goibiboRating?.rating}
										<div class="text-[#07d704f] lg:border border-[#7d704f] rounded-lg p-2.5">
											<div class="flex justify-center gap-5 flex-col">
												<img
													src="/images/goibibo.png"
													alt="images"
													class="h-10 w-full object-contain"
												/>
												<div class="flex items-center justify-center gap-2">
													<span class="text-4xl font-semibold">{goibiboRating?.rating}</span>
													<span class="text-sm">/ {goibiboRating?.scale}</span>
												</div>
												<div class="flex items-center justify-center gap-2">
													<span class="text-sm">{goibiboRating?.count}</span>
												</div>
											</div>
										</div>
									{/if}
								</SplideSlide>
								<SplideSlide class="py-5 lg:py-0 px-5">
									{#if mmtRating?.rating}
										<div class="text-[#07d704f] lg:border border-[#7d704f] rounded-lg p-2.5">
											<div class="flex justify-center gap-5 flex-col">
												<img
													src="/images/makemytrip.png"
													alt="images"
													class="h-10 w-full object-contain"
												/>
												<div class="flex items-center justify-center gap-2">
													<span class="text-4xl font-semibold">{mmtRating?.rating}</span>
													<span class="text-sm">/ {mmtRating?.scale}</span>
												</div>
												<div class="flex items-center justify-center gap-2">
													<span class="text-sm">{mmtRating?.count} Ratings</span>
												</div>
											</div>
										</div>
									{/if}
								</SplideSlide>
								<SplideSlide class="py-5 lg:py-0 px-5">
									{#if tripRating?.rating}
										<div class="text-[#07d704f] lg:border border-[#7d704f] rounded-lg p-2.5">
											<div class="flex justify-center gap-5 flex-col">
												<img
													src="/images/trip.png"
													alt="images"
													class="h-10 w-full object-contain"
												/>
												<div class="flex items-center justify-center gap-2">
													<span class="text-4xl font-semibold">{tripRating?.rating}</span>
													<span class="text-sm">/ {tripRating?.scale}</span>
												</div>
												<div class="flex items-center justify-center gap-2">
													<span class="text-sm">{tripRating?.count} Ratings</span>
												</div>
											</div>
										</div>
									{/if}
								</SplideSlide>
								<SplideSlide class="py-5 lg:py-0 px-5">
									{#if ctripRating?.rating}
										<div class="text-[#07d704f] lg:border border-[#7d704f] rounded-lg p-2.5">
											<div class="flex justify-center gap-5 flex-col">
												<img
													src="/images/ctrip.png"
													alt="images"
													class="h-10 w-full object-contain"
												/>
												<div class="flex items-center justify-center gap-2">
													<span class="text-4xl font-semibold">{ctripRating?.rating}</span>
													<span class="text-sm">/ {ctripRating?.scale}</span>
												</div>
												<div class="flex items-center justify-center gap-2">
													<span class="text-sm">{ctripRating?.count} Ratings</span>
												</div>
											</div>
										</div>
									{/if}
								</SplideSlide> -->
							</Splide>
						</div>
					</div>
				</div>
			</div>
			<div
				class="pt-6 pb-1 border-t border-[#7d704f] mt-8 lg:flex lg:items-center lg:justify-between lg:mt-5"
			>
				<div class="text-xs text-center">
					© {currentYear} The Trans Resort Bali. All rights reserved.
				</div>
				<div class="mt-3 flex items-center justify-center divide-x divide-[#7d704f] lg:mt-0">
					<!-- <div class="pr-3">
						<a
							class="block rounded-sm overflow-hidden w-8"
							href="https://www.transresortbali.com.cn/"
						>
							<img
								class="block w-full"
								src="/images/china-flag.webp"
								alt="China Flag"
								loading="lazy"
							/>
						</a>
					</div> -->
					<ul class="flex items-center pl-2.5 gap-x-2">
						<li>
							<a
								class="w-6 block"
								target="_blank"
								href="https://wa.me/6281138008889"
								aria-label="WhatsApp The Trans Resort Bali"
							>
								<svg
									class="block w-full fill-[#7d704f]"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M186.68,146.63l-32-16a6,6,0,0,0-6,.38L133,141.46A42.49,42.49,0,0,1,114.54,123L125,107.33a6,6,0,0,0,.38-6l-16-32A6,6,0,0,0,104,66a38,38,0,0,0-38,38,86.1,86.1,0,0,0,86,86,38,38,0,0,0,38-38A6,6,0,0,0,186.68,146.63ZM152,178a74.09,74.09,0,0,1-74-74,26,26,0,0,1,22.42-25.75l12.66,25.32-10.39,15.58a6,6,0,0,0-.54,5.63,54.43,54.43,0,0,0,29.07,29.07,6,6,0,0,0,5.63-.54l15.58-10.39,25.32,12.66A26,26,0,0,1,152,178ZM128,26A102,102,0,0,0,38.35,176.69L26.73,211.56a14,14,0,0,0,17.71,17.71l34.87-11.62A102,102,0,1,0,128,26Zm0,192a90,90,0,0,1-45.06-12.08,6.09,6.09,0,0,0-3-.81,6.2,6.2,0,0,0-1.9.31L40.65,217.88a2,2,0,0,1-2.53-2.53L50.58,178a6,6,0,0,0-.5-4.91A90,90,0,1,1,128,218Z"
									></path></svg
								>
							</a>
						</li>
						<li>
							<a
								class="w-6 block"
								target="_blank"
								href="https://www.facebook.com/thetransresortbali/?rf=513256195393338"
								aria-label="Facebook The Trans Resort Bali"
							>
								<svg
									class="bloc w-full fill-[#7d704f]"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm6,191.8V150h26a6,6,0,0,0,0-12H134V112a18,18,0,0,1,18-18h16a6,6,0,0,0,0-12H152a30,30,0,0,0-30,30v26H96a6,6,0,0,0,0,12h26v67.8a90,90,0,1,1,12,0Z"
									></path></svg
								>
							</a>
						</li>
						<li>
							<a
								class="w-6 block"
								target="_blank"
								href="https://www.youtube.com/@TheTransResortBali"
								aria-label="Youtube The Trans Resort Bali"
							>
								<svg
									class="block w-full fill-[#7d704f]"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M163.33,123l-48-32A6,6,0,0,0,106,96v64a6,6,0,0,0,9.33,5l48-32a6,6,0,0,0,0-10ZM118,148.79V107.21L149.18,128ZM232.4,70a22,22,0,0,0-13.28-15C185,41.79,130.27,42,128,42s-57-.21-91.16,13A22,22,0,0,0,23.6,70C21.05,79.89,18,98,18,128s3.05,48.11,5.6,58a22,22,0,0,0,13.28,15C71,214.21,125.72,214,128,214h.71c6.91,0,58-.44,90.45-13a22,22,0,0,0,13.28-15c2.55-9.87,5.6-27.93,5.6-58S235,79.89,232.4,70ZM220.78,183a10,10,0,0,1-6,6.86C182.78,202.19,128.58,202,128,202s-54.71.2-86.75-12.17a10,10,0,0,1-6-6.86C32.84,173.78,30,156.78,30,128s2.84-45.78,5.22-55a10,10,0,0,1,6-6.86C72.06,54.26,123.53,54,127.76,54H128c.54,0,54.71-.2,86.75,12.17a10,10,0,0,1,6,6.86c2.38,9.19,5.22,26.19,5.22,55S223.16,173.78,220.78,183Z"
									></path></svg
								>
							</a>
						</li>
						<li>
							<a
								class="w-6 block"
								target="_blank"
								href="https://www.instagram.com/thetransresortbali/"
								aria-label="Instagram The Trans Resort Bali"
							>
								<svg
									class="block w-full fill-[#7d704f]"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M128,82a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162ZM176,26H80A54.06,54.06,0,0,0,26,80v96a54.06,54.06,0,0,0,54,54h96a54.06,54.06,0,0,0,54-54V80A54.06,54.06,0,0,0,176,26Zm42,150a42,42,0,0,1-42,42H80a42,42,0,0,1-42-42V80A42,42,0,0,1,80,38h96a42,42,0,0,1,42,42ZM190,76a10,10,0,1,1-10-10A10,10,0,0,1,190,76Z"
									></path></svg
								>
							</a>
						</li>
						<li>
							<a
								class="w-6 block"
								target="_blank"
								href="https://www.tiktok.com/@transresortbali"
								aria-label="Tripadvisor The Trans Resort Bali"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									class="block w-full fill-[#7d704f]"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M224,72a48.05,48.05,0,0,1-48-48,8,8,0,0,0-8-8H128a8,8,0,0,0-8,8V156a20,20,0,1,1-28.57-18.08A8,8,0,0,0,96,130.69V88a8,8,0,0,0-9.4-7.88C50.91,86.48,24,119.1,24,156a76,76,0,0,0,152,0V116.29A103.25,103.25,0,0,0,224,128a8,8,0,0,0,8-8V80A8,8,0,0,0,224,72Zm-8,39.64a87.19,87.19,0,0,1-43.33-16.15A8,8,0,0,0,160,102v54a60,60,0,0,1-120,0c0-25.9,16.64-49.13,40-57.6v27.67A36,36,0,1,0,136,156V32h24.5A64.14,64.14,0,0,0,216,87.5Z"
									></path></svg
								>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</footer>
